import React, { Component } from "react";
import _ from "lodash";
import { connect } from "react-redux";
import { bindActionCreators, compose } from "redux";
import { withStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import {
  WithStyles,
  createStyles,
  Button,
  Typography,
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Link,
  LinearProgress,
  Checkbox,
  FormControlLabel,
  RadioGroup,
  Radio,
  MenuItem,
  ListItemText,
  InputBase,
} from "@material-ui/core";
import {
  CloseOutlined as CloseIcon,
  FileCopy as CopyIcon,
} from "@material-ui/icons";
import Chip from "@material-ui/core/Chip";

import { MyPATIconButton, MyPATDialog, SearchField, MyPATSelect } from "../../common";
import ContentData, { User } from "../types/ContentData";
import { UserData, UserToShareWith } from "../types/ContentData";
import {
  UserGroupsBody,
  SectionWiseAccess,
  Section,
} from "../types/UserGroupsBody";
import contentService from "../services/contentService";
import userService from "../services/userService";
import { usersList } from "../actions/userActions";
import { getClient } from "../../client/ClientServices";
import moment from "moment";
import { getClientId } from "../../../utils";
import { ExpandItems } from "../../common/ExpandItems";
import {getSubjectList} from "../../userManagement/actions/userActions";
import { isThisSecond } from "date-fns/esm";
const styles = (theme: Theme) =>
  createStyles({
    widthSM: {
      width: 568,
    },
    widthMD: {
      maxWidth: 720,
    },
    tableHead: {
      "& th": {
        color: "rgb(51 51 51)",
        fontFamily: "Nunito",
        fontWeight: 600,
        fontSize: 16,
        lineHeight: "22px",
        borderBottom: "none",
        padding: "23px 20px 0px",
        width: 300,
      },
    },
    colorSecondary: {
      backgroundColor: "#1D7DEA",
      color: "5.5px 5px 5px 5.5px",
    },
    progressBar: {
      borderRadius: 5,
    },
    group: {
      display: "flex",
      flexDirection: "row",
      alignItems: "center",
      "& label": {
        marginLeft: 0,
        "&:nth-of-type(1)": {
          marginRight: 0,
        },
      },
    },
    customLabel: {
      marginRight: "5px",
    },
    linearProgressBar: {
      padding: 8,
      margin: "4px 0px 2px",
      backgroundColor: "rgb(210 210 210)",
    },
    progressValue: {
      position: "absolute",
      margin: "-20px 12%",
      color: "rgb(255 255 255)",
    },
    btnWidth: {
      width: 110,
      marginBottom: 12,
    },
    seggestedListItem: {
      maxWidth: 300,
    },
    userChipColor: {
      border: "1px solid #5A0757",
      color: "#5A0757",
      fontWeight: "bold",
    },
    groupsChipColor: {
      border: "1px solid #5D7087;",
      color: "#5D7087;",
    },
    clientChipColor: {
      border: "1px solid #0A8AB9",
      color: "#0A8AB9",
    },
    userRoleChip: {
      verticalAlign: "middle",
      margin: "0px 4px 0px 10px",
      background: "#FFFFFF",
      padding: "0px 10px",
      borderRadius: 18,
      "& svg": {
        color: "rgb(153, 153, 153)",
      },
    },
    root: {
      display: "flex",
      flexWrap: "wrap",
    },
    formControl: {
      margin: theme.spacing.unit,
      minWidth: 120,
      width: "95%",
    },
    chips: {
      display: "flex",
      flexWrap: "wrap",
    },
    chip: {
      margin: theme.spacing.unit / 4,
    },
    noLabel: {
      marginTop: theme.spacing.unit * 3,
    },
    permissionSelect: {
      width: "100%",
      border: "1px solid #dfdfdf",
      height: 38,
      padding: "8px 16px",
      position: "relative",
      fontSize: 16,
      minWidth: 24,
      background:
        "url(/assets/svg/goalManagement/arrow-down.svg) 0 0 no-repeat",
      transition:
        "border-color 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms,box-shadow 300ms cubic-bezier(0.4, 0, 0.2, 1) 0ms",
      boxSizing: "border-box",
      borderRadius: 4,
      paddingRight: 40,
      backgroundColor: "white",
      WebkitAppearance: "none",
      backgroundPositionX: "90%",
      backgroundPositionY: "center",
      color: "#666",
    },
    peopleText: {
      color: "rgb(102 102 102)",
      fontSize: 16,
    },
    searchRoot: {
      padding: theme.spacing.unit / 4,
      marginTop: 6,
      marginBottom: theme.spacing.unit,
      border: "1px solid #DFDFDF",
      width: "100%",
      height: 44,
      borderRadius: 4,
    },
    sharedWithText: {
      marginRight: theme.spacing.unit / 2,
      fontWeight: 600,
      fontSize: "1.2rem",
      lineHeight: "2.5",
    },
    userChipRoot: {
      padding: theme.spacing.unit,
      margin: "5px 10px 6px 0",
      borderRadius: "4px",
      background: "transparent",
      border: "1px solid #1d7dea",
    },
    selectedChip: {
      background: "#F2F5F6",
    },
    userChipLabel: {
      color: "#1d7dea",
      fontSize: 14,
      fontFamily: "Nunito",
      paddingLeft: 0,
      paddingRight: 6,
      textTransform: "capitalize",
      margin: "10px 0",
      "&:first-of-type": {
        marginTop: 0,
        marginBottom: 0,
      },
    },
    userChipIcon: {
      color: "#1d7dea",
      margin: "0px -7px 0 -8px",
    },
    suggestContainer: {
      position: "relative",
      width: "100%",
    },
    suggestList: {
      position: "absolute",
      top: 94,
      left: "0",
      background: "#fff",
      // boxShadow: "0px 0px 2px #ccc",
      padding: 0,
      zIndex: 10,
      listStyleType: "none",
      marginTop: 0,
      width: "100%",
      "& li:hover": {
        cursor: "pointer",
      },
    },
    suggestItem: {
      padding: theme.spacing.unit,
      paddingBottom: theme.spacing.unit + 4,
      cursor: "pointer",
      lineHeight: "16px",
      zIndex: 11,
      "&::after": {
        content: "",
        display: "table",
        clear: "both",
      },
    },
    tableCell: {
      fontFamily: "Nunito",
      fontStyle: "normal",
      fontWeight: 600,
      fontSize: 16,
      lineHeight: "18px",
      textAlign: "center",
      color: "rgb(51, 51, 51)",
    },
    borderNone: {
      border: "none",
      height: 40,
    },
    paddingSM: {
      padding: "4px 0px 0px",
      minWidth: 130,
      "&:last-child": {
        padding: "4px 0px 0px",
      },
    },
    tableRow: {
      height: 36,
    },
    tableContainer: {
      height: "auto",
      maxHeight: 400,
      overflowY: "auto",
      borderRadius: 4,
      background: "#FBFBFB",
      margin: "20px 7px -14px",
      border: "1px solid rgba(220, 220, 220, 0.4)",
      width: 766,
      "& td": {
        borderBottom: "1px solid rgb(0 0 0 / 0%)",
        fontSize: 14,
        color: "#666666",
        maxWidth: 100,
        textOverflow: "ellipsis",
        wordBreak: "break-word",
        padding: "0px 20px 23px",
      },
    },
    // custom radio
    customRadio: {
      // marginRight: '35px',
    },
    marginZero: {
      marginLeft: 0,
    },
    marginTB10: {
      margin: "10px 0",
    },
    checkbox: {
      padding: 0,
      top: 0,
      left: 0,
      width: 20,
      height: 20,
      "-moz-appearance": "none",
      color: "rgb(204, 204, 204)",
      backgroundColor: "#fff",
      border: "1px solid #979797",
      borderRadius: 4,
      marginRight: 14,
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: "Nunito",
        fill: "#979797",
        opacity: 0,
      },
    },
    primaryColor: {
      color: "rgb(29 125 234)",
    },
    multiCheckedCheckbox: {
      backgroundColor: "#1d7dea !important",
      border: "1px solid #1d7dea !important",
      borderRadius: 2,
      opacity: 1,
      color: "#99a1a7",
      "&::before": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 1,
        left: 4,
        width: 4,
        height: 8,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
      "&:hover": {
        backgroundColor: "#1d7dea",
      },
    },
    multiCheckbox: {
      padding: 0,
      top: 0,
      left: 0,
      width: 16,
      height: 16,
      "-moz-appearance": "none",
      color: "rgb(204, 204, 204)",
      backgroundColor: "#fff",
      border: "1px solid #979797",
      borderRadius: 2,
      marginRight: 8,
      "& svg": {
        fontSize: "1.5rem",
        fontFamily: "Nunito",
        fill: "#979797",
        opacity: 0,
      },
    },
    checkedCheckbox: {
      backgroundColor: "#1d7dea !important",
      border: "1px solid #1d7dea !important",
      borderRadius: 4,
      opacity: 1,
      color: "#99a1a7",
      "&::before": {
        content: "''",
        fontSize: 14,
        position: "absolute",
        top: 1,
        left: 6,
        width: 4,
        height: 10,
        border: "solid #fff",
        borderWidth: "0 2px 2px 0",
        transform: "rotate(45deg)",
      },
      "&:hover": {
        backgroundColor: "#1d7dea",
      },
    },
    sectionAccessHeading: {
      fontSize: 16,
      fontWeight: 600,
      color: "#666",
      margin: "10px 0 0 0",
    },
    accessFrame: {
      position: "relative",
      borderRadius: 4,
      width: "100%",
      margin: "23px 0",
      border: "1px solid #E4E4E4",
      padding: "23px 13px",
      "&:nth-of-type(1)": {
        marginTop: 35,
      },
    },
    frameHeading: {
      position: "absolute",
      top: "-16px",
      left: 12,
      padding: "5px",
      backgroundColor: "#fff",
      fontSize: 16,
      fontWeight: 600,
      color: "#333",
      lineHeight: "18px",
    },
    fontSize_SM: {
      fontSize: 16,
    },
    fontSize_MD: {
      fontSize: 18,
    },
    fontSize_LG: {
      fontSize: 20,
    },
    fontWeight_SM: {
      fontWeight: 400,
    },
    fontSize24: {
      fontSize: 24,
    },
    fontWeight_MD: {
      fontWeight: 600,
    },
    grey: {
      color: "#666666",
    },
    label: {
      color: "#666",
      fontSize: 16,
      fontWeight: 600,
      margin: "15px 0 5px 0",
    },
    dFlex: {
      display: "flex",
      alignItems: "center",
      "& p": {
        margin: "0 15px",
      },
    },
    cursor: {
      color: "#1d7dea",
      "&:hover": {
        cursor: "pointer",
      },
    },
    cursorLink: {
      marginRight: 20,
      color: "#666",
      display: "inline-block",
      "&:hover": {
        cursor: "pointer",
      },
    },
    subText: {
      fontSize: 10,
      fontWeight: 200,
      fontFamily: "Nunito",
      position: "relative",
      top: 17,
      left: 65,
    },
    infoImg: {
      height: 12,
      width: 12,
      position: "relative",
      top: 17,
      left: 61,
    },
    optionContainer: {
      "& input": {
        border: "1px solid #DFDFDF",
        width: "100%",
        padding: "10px",
      },
    },
    optionlistContainer: {
      position: "relative",
      "&::after": {
        top: "5px",
        right: "18px",
        border: "solid rgb(0 0 0 / 0%)",
        height: 0,
        content: '" "',
        zIndex: 999,
        position: "absolute",
        transform: "rotate(226deg)",
        boxShadow: "1px 1px 1px #DFDFDF",
        background: "rgb(255 255 255)",
        borderColor: "rgb(194 225 245 / 0%)",
        borderWidth: 9,
        borderBottomColor: "rgb(255 255 255)",
      },
    },
    optionList: {
      width: "100%",
      border: "1px solid #DFDFDF",
      display: "block",
      padding: "10px",
      position: "absolute",
      backgroundColor: "#fff",
      top: "13px",
      borderRadius: "7px",
      maxHeight: 250,
      overflowX: "hidden",
      overflowY: "auto",
      "& input": {
        marginTop: 10,
        paddingLeft: 40,
      },
      "& span": {
        display: "block",
        padding: '2px 5px'
      },

      // top: "-16px",
      // right: "15px",
      // width: 0,
      // height: 0,
      // content: '" "',
      // position: "absolute",
      // marginLeft: "-20px",
      // borderLeft: "10px solid transparent",
      // borderRight: "10px solid transparent",
      // borderBottom: "15px solid #dadada",
      // borderTopLeftRadius: "20px",
      // borderTopRightRadius: "0px",
      // }
    },
    searchContainer: {
      position: "sticky",
      top: '-10px',
      zIndex: 1,
      "& img": {
        left: "9px",
        position: "absolute",
        top: "20px",
      },
    },
  });

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
  PaperProps: {
    style: {
      maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
      width: 250,
    },
  },
};

interface ShareUserData {
  user: UserToShareWith;
}

type ShareType = "client" | "users";
interface Props extends WithStyles<typeof styles> {
  classes: any;
  contentList: ContentData[];
  isShareDialogOpen: boolean;
  onShared: Function;
  usersList: Function;
  dropdownSelectedValue: boolean;
  UnSelectedIDs: any[];
  filters: any;
  selectAllContent: boolean;
  totalCount: number;
  subjectList: any[];
  getSubjectList: any;
}
interface State {
  selectedUsers: UserData[];
  selectedGroups: UserGroupsBody[];
  selectedPermission: string;
  usersOfSelectedClient: User[];
  groups: UserGroupsBody[];
  removedIds: string[];
  suggestedClientsList: any[];
  suggestedUsersList: any[];
  suggestedSubjectList:any[];
  showSuggestedList: boolean;
  showFullAlreadyShared: boolean;
  allSharedId: any[];
  isShare: boolean;
  processedRecord: any;
  processStartDate: any;
  totalRecord: any;
  sectionWiseAccess: SectionWiseAccess[];
  shareContentWith: ShareType;
  sharedUsersList: ShareUserData[];
  clientSearchText: string;
  userSearchText: string;
  selectedSubjects:any [];
  isSubjectAllSelect:boolean;
  showSubjects:boolean;
  filteredSubjectList:any []
}

class ContentShareModal extends Component<Props, State> {
  state: State = {
    sharedUsersList: [], // used when sharing with users
    usersOfSelectedClient: [], // used when sharing with users

    selectedUsers: [],
    selectedGroups: [],
    selectedPermission: "VIEW",
    groups: [],
    showSuggestedList: false,
    suggestedClientsList: [],
    suggestedUsersList: [],
    suggestedSubjectList:[],
    removedIds: [],
    showFullAlreadyShared: false,
    allSharedId: [],
    isShare: false,
    processedRecord: null,
    processStartDate: null,
    totalRecord: null,
    sectionWiseAccess: [],
    shareContentWith: "client",
    clientSearchText: '',
    userSearchText: '',
    isSubjectAllSelect:false,
    selectedSubjects:[],
    showSubjects:false,
    filteredSubjectList:[]
  };

  constructor(props: Props) {
    super(props);

    this.onShared = this.onShared.bind(this);
    this.setPermission = this.setPermission.bind(this);
    this.showSuggested = this.showSuggested.bind(this);
    this.getSubjectSuggestions=_.debounce(this.getSubjectSuggestions,200);
  }

  componentDidMount() {
    // userService.list().then(users => {
    // 	this.setState({ users });
    // })

    // userService.group().then(groups => {
    // 	this.setState({ groups });
    // })
    //TODO - implement seach and pagination later limit=10&skip=0&search=mypat
    getClient("").then((res: any) => {
      this.setState({ groups: res.responseObject });
    });
    this.props.getSubjectList();
  }
  componentDidUpdate(prevProps: Props, prevState: State) {
    // Typical usage (don't forget to compare props):
    if (this.props.isShareDialogOpen !== prevProps.isShareDialogOpen) {
      this.filterSharedGroupsUser();
    }
    if(prevProps.subjectList!==this.props.subjectList){
      this.props.subjectList.sort((a:any,b:any)=>{
        if(a.name < b.name) { return -1; }
        if(a.name > b.name) { return 1; }
        return 0;
      });
      this.setState({filteredSubjectList:[...this.props.subjectList]});
    }
    const prevSelectedGroup = prevState.selectedGroups;
    const currentlySelectedGroup = this.state.selectedGroups;
    const shareType = this.state.shareContentWith;
    if (
      !_.isEmpty(currentlySelectedGroup) &&
      prevSelectedGroup !== currentlySelectedGroup &&
      shareType === "users"
    ) {
      this.getUsersOfSelectedClient();
    }
  }

  getUsersOfSelectedClient = async () => {
    try {
      const { selectedGroups } = this.state;
      const clientIds = selectedGroups.map(({ _id }) => _id);
      const users = await contentService.getUsersByClientIds({ clientIds });
      this.setState({
        usersOfSelectedClient: users,
      });
    } catch (error) {
      console.log(error);
    }
    return [];
  };

  handleShareContentWith = (event: any) => {
    const shareContentWith = event.target.value;
    this.resetEditData();
    this.setState({
      shareContentWith,
    });
  };

  filterSharedGroupsUser() {
    let { contentList } = this.props;
    let allowedToArr = _.get(contentList[0], "aclMetaData.allowedTo", []);
    let allSharedIds: any[] = [];

    // _.forEach(allowedToArr, (data: any) => {
    // 	if (data.user.id == null) {
    // 		allSharedIds.push(data.userGroup.id._id)
    // 	}
    // 	else if (data.userGroup.id == null) {
    // 		allSharedIds.push(data.user.id._id)
    // 	}
    // })
    // this.setState({
    // 	allSharedId: allSharedIds
    // });
  }
  setPermission(e: any) {
    let { value } = e.target;
    if (value === "VIEW") {
      this.setState({ sectionWiseAccess: [] });
    }
    this.setState({ selectedPermission: value });
  }

  showSuggested(action: boolean) {
    if (action) {
      this.setState({ showSuggestedList: true });
    } else {
      setTimeout(() => {
        this.setState({ showSuggestedList: false });
      }, 200);
    }
  }
  checkCountInContent(type: string) {
    const { contentList } = this.props;
    return contentList.filter(function(val: any) {
      return val.contentTypeCode === type;
    }).length;
  }

  changePermission(event: any, module: any, key?: any) {
    let updatedPermissions = JSON.parse(
      JSON.stringify(this.state.sectionWiseAccess)
    );
    // check if module exists
    const data = updatedPermissions.filter(function(val: any) {
      if (val.module === module) {
        return val;
      }
    });
    var foundIndex = updatedPermissions.findIndex(
      (item: any) => item.module === module
    );
    // if module exist
    if (data && data.length > 0) {
      let sectionData: any = JSON.parse(
        JSON.stringify(this.state.sectionWiseAccess[foundIndex])
      );
      if (event.target.checked) {
        // if checkbox is checked
        let newSection = {
          module: key,
          access: ["edit"],
        };
        sectionData.sections.push(newSection);
        updatedPermissions[foundIndex] = sectionData;
      } else {
        // if checkbox is unchecked
        let index = sectionData.sections.findIndex(
          (item: any) => item.module === key
        );
        sectionData.sections.splice(index, 1);
        if (sectionData.sections.length === 0) {
          updatedPermissions.splice(foundIndex, 1);
        } else {
          updatedPermissions[foundIndex] = sectionData;
        }
      }
    } else {
      // if module doesn't exist
      let section: SectionWiseAccess = {
        module: module,
        sections: [
          {
            module: key,
            access: ["edit"],
          },
        ],
      };
      updatedPermissions.push(section);
    }
    this.setState({
      sectionWiseAccess: updatedPermissions,
    });
  }
  checkPermissionExist(module: any, key: any) {
    let data =
      this.state.sectionWiseAccess.filter(function(val: any) {
        if (val.module === module) {
          let sections =
            val.sections &&
            val.sections.filter(function(sectionData: any) {
              if (sectionData.module === key) {
                return sectionData;
              }
            });
          return sections.length > 0;
        }
      }).length > 0;
    return data;
  }
  renderPermissionCheckbox(label: any, module: any, key?: any) {
    const { classes } = this.props;
    return (
      <FormControlLabel
        className={[classes.customRadio, classes.marginTB10].join(" ")}
        control={
          <Checkbox
            checked={this.checkPermissionExist(module, key)}
            classes={{
              root: classes.checkbox,
              checked: classes.checkedCheckbox,
              colorPrimary: classes.primaryColor,
            }}
            onChange={() => this.changePermission(event, module, key)}
            color="primary"
          />
        }
        label={label}
        classes={{ label: [classes.fontSize_SM, classes.grey].join(" ") }}
      />
    );
  }

  setSearchText = (shareType: ShareType, value: string) => {
    this.setState(prevState => {
      let field = shareType === 'client' ? 'clientSearchText' : 'userSearchText';
      return {
        ...prevState,
        [field]: value
      }
    })
  }

  getSuggestions = (shareType: ShareType) => (e: any) => {
    // const { users } = this.props;
    const { groups, usersOfSelectedClient } = this.state;
    let suggestedClientsList: any[] = this.state.suggestedClientsList;
    let suggestedUsersList = this.state.suggestedUsersList;
    let { value } = e.target;
    this.setSearchText(shareType, value)
    value = value.toLocaleLowerCase();
    suggestedClientsList = [];
    suggestedUsersList = [];
    if (shareType === "users" && value) {
      usersOfSelectedClient.forEach((u: User) => {
        const fullName = `${u.firstName} ${u.lastName}`;
        if (
          (fullName && fullName.toLocaleLowerCase().search(value) != -1) ||
          (u.email && u.email.toLocaleLowerCase().search(value) != -1)
        ) {
          suggestedUsersList.push({ _id: u._id, name: fullName, type: "user" });
        }
      });
      suggestedUsersList = _.take(suggestedUsersList, 3);
    } else if (value) {
      groups &&
      groups.forEach((ug: UserGroupsBody) => {
        if (ug.name && ug.name.toLocaleLowerCase().search(value) != -1) {
          suggestedClientsList.push({
            _id: ug._id,
            name: ug.name,
            type: "group",
          });
        }
      });
    suggestedClientsList = _.take(suggestedClientsList, 3);
    }
    this.setState({ suggestedClientsList, suggestedUsersList });
  };

  onClientSuggestionClick = (id: string, isSingleChoice: boolean) => {
    const { groups, selectedGroups }: any = this.state;
    let newSelectedGroups: any[] = [];
    if (!isSingleChoice) {
      newSelectedGroups = newSelectedGroups.concat(
        selectedGroups.filter((ug: UserGroupsBody) => ug._id != id)
      );
    }
    newSelectedGroups = newSelectedGroups.concat(
      groups.filter((ug: UserGroupsBody) => ug._id == id)
    );
    this.setState({
      selectedGroups: newSelectedGroups,
      suggestedClientsList: [],
      sharedUsersList: [],
      clientSearchText: ''
    });
  };

  onUserSuggestionClick = (id: string) => {
    let { sharedUsersList, usersOfSelectedClient } = this.state;
    const selectedUser = usersOfSelectedClient.find(({ _id }) => _id === id);
    if (!selectedUser) {
      return;
    }
    sharedUsersList = [
      ...sharedUsersList.filter(({ user: { id: userId } }) => userId !== id),
      {
        user: {
          id,
          email: selectedUser.email,
          name: `${selectedUser.firstName} ${selectedUser.lastName}`,
        },
      },
    ];

    this.setState({
      sharedUsersList,
      suggestedUsersList: [],
      userSearchText: ''
    });
  };

  removeSelected(id: string, type: ShareType) {
    let { selectedGroups, sharedUsersList } = this.state;

    if (type === "client") {
      selectedGroups = selectedGroups.filter(
        (ug: UserGroupsBody) => ug._id != id
      );
      sharedUsersList = [];
    } else {
      sharedUsersList = sharedUsersList.filter(
        ({ user: { id: userId } }) => userId !== id
      );
    }

    this.setState({ selectedGroups, sharedUsersList });
  }

  removeAlreadyExist(c: any) {
    let removedIds: string[] = this.state.removedIds;
    removedIds.push(_.get(c, "user.id._id", _.get(c, "userGroup.id._id", "")));
    this.setState({ removedIds });
  }

  getShareTypeBasedPayload = () => {
    const { shareContentWith, sharedUsersList } = this.state;

    if (shareContentWith === "users") {
      return {
        sharedUsersList,
        removedUsersList: [],
      };
    } else {
      return {
        sharedClientIdList: this.state.selectedGroups.map(
          (ug: UserGroupsBody) => ug._id
        ),
        removedIds: [],
      };
    }
  };

  onShared(sharing: boolean) {
    const {
      dropdownSelectedValue,
      UnSelectedIDs,
      isShareDialogOpen,
      filters,
      contentList,
      selectAllContent,
      totalCount,
      subjectList
    } = this.props;
    const{selectedSubjects}=this.state;
    let limit = 20;
    if (selectAllContent) {
      limit = totalCount;
    }
    let searchText = "";
    //@ts-ignore
    if (filters) {
      searchText = filters.searchText;
    }
    if (contentList.length > 0 && !selectAllContent) {
      limit = contentList.length;
      searchText = contentList
        .map((content: any) => content.contentId)
        .join(",");
    }
    let subjects:any=[];
    if(selectedSubjects.length>0){
        let subjectIdMap:any={};
        subjectList.forEach((sub)=>{
          subjectIdMap[sub._id]=sub;
        });
        selectedSubjects.forEach((id)=>{
          subjects.push({
            name:subjectIdMap[id].name,
            id:id
          })
        });
    }
    if (sharing) {
      let body = {
        //contentList: this.props.contentList.map(c => c._id),
        ...this.getShareTypeBasedPayload(),
        allSelected: dropdownSelectedValue,
        UnSelectedIDs: UnSelectedIDs || [],
        limit: limit,
        page: 1,
        ...filters,
        searchText,
        access: this.state.selectedPermission,
        subjects
      };
      if (this.state.sectionWiseAccess.length > 0) {
        body.sectionWiseAccess = this.state.sectionWiseAccess;
      }
      contentService
        .share(body)
        .then((res: any) => {
          if (res.statusCode == 422) {
            this.setState({
              isShare: true,
              processedRecord: res.responseObject.processedRecord,
              processStartDate: res.responseObject.createdAt,
              totalRecord: res.responseObject.totalRecord,
            });
          } else {
            this.setState({
              removedIds: [],
              suggestedClientsList: [],
              selectedUsers: [],
              selectedGroups: [],
              selectedSubjects:[],
              showSuggestedList: false,
              sharedUsersList:[],
              sectionWiseAccess:[],
              isSubjectAllSelect:false
            });
            setTimeout(() => {
              this.props.onShared(sharing);
            }, 1000);
          }
        })
        .catch((error) => {
          console.error(error);
        });

    } else {
      this.resetEditData();
      this.props.onShared(sharing);
    }
  }

  mapToContent() {
    //local mapping
    let { contentList } = this.props;
    const {
      removedIds,
      selectedGroups,
      selectedUsers,
      selectedPermission,
    } = this.state;
    contentList.forEach((content) => {
      if (!(content.aclMetaData && content.aclMetaData.allowedTo)) {
        content.aclMetaData = {
          ...content.aclMetaData,
          allowedTo: [],
        };
      }

      //@ts-ignore
      content.aclMetaData.allowedTo = content.aclMetaData.allowedTo.filter(
        (at: any) =>
          !(
            removedIds.includes(at.user.id) ||
            removedIds.includes(at.userGroup.id)
          )
      );
      //@ts-ignore
      content.aclMetaData.allowedTo = content.aclMetaData.allowedTo.filter(
        (at: any) =>
          !(
            selectedGroups.includes(at.user.id) ||
            selectedUsers.includes(at.userGroup.id)
          )
      );

      selectedGroups.forEach((g) => {
        content.aclMetaData.allowedTo.push({ user: null, userGroup: g });
      });
      selectedUsers.forEach((u) => {
        content.aclMetaData.allowedTo.push({ user: u, userGroup: null });
      });
    });
  }

  userType(type: string) {
    const { classes } = this.props;
    return (
      <span className={[classes.userRoleChip, classes.userChipColor].join(" ")}>
        {type}{" "}
      </span>
    );
  }
  renderer = () => {
    const { subjectList} = this.props;
    const{selectedSubjects}=this.state;
    console.log(subjectList)
    return subjectList
      .reduce((acc: string[], { _id, name }) => {
        if (selectedSubjects.includes(_id)) {
          acc.push(name);
        }
        return acc;
      }, [])
      .join(", ");
  };
  sharingProgress(classes: any) {
    const { processedRecord, processStartDate, totalRecord } = this.state;
    return (
      <>
        <Grid container alignItems="center">
          <Grid className={classes.tableContainer}>
            <Table>
              <TableHead classes={{ root: classes.tableHead }}>
                <TableRow classes={{ head: classes.tableRow }}>
                  <TableCell align="left">No of Content Shared</TableCell>
                  <TableCell align="left">Date & Time</TableCell>
                  <TableCell align="left">Status</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                <TableRow key={1} classes={{ root: classes.tableRow }}>
                  <TableCell align="left">{totalRecord}</TableCell>
                  <TableCell align="left">
                    {//@ts-ignore
                    moment(processStartDate).format("DD MMMM YYYY hh:mm")}
                  </TableCell>
                  <TableCell align="left">
                    <LinearProgress
                      variant="determinate"
                      classes={{
                        colorSecondary: classes.colorSecondary,
                        barColorPrimary: classes.colorSecondary,
                        bar: classes.progressBar,
                        root: classes.linearProgressBar,
                      }}
                      value={parseInt(
                        ((processedRecord / totalRecord) * 100).toString()
                      )}
                    />
                    <span>
                      <Typography
                        variant="body2"
                        color="default"
                        classes={{ root: classes.progressValue }}
                      >
                        {parseInt(
                          ((processedRecord / totalRecord) * 100).toString()
                        )}
                        %
                      </Typography>
                    </span>
                  </TableCell>
                </TableRow>
              </TableBody>
            </Table>
          </Grid>
        </Grid>
      </>
    );
  }
  handleSubjectChange=(event:any)=>{
    let subjectID = event.target.value;
    let isChecked=event.target.checked;
    let{isSubjectAllSelect,selectedSubjects,filteredSubjectList}=this.state;
    let newSelectedSubjects=[...selectedSubjects];
    
    if(isChecked){
      if(subjectID==='SelectAll'){
        newSelectedSubjects=[];
        isSubjectAllSelect=true;
        filteredSubjectList.forEach((sub)=>{
          newSelectedSubjects.push(sub._id);
         });
      }else{
         newSelectedSubjects.push(subjectID);
         isSubjectAllSelect=false;
      }
    }else{
      if(subjectID==='SelectAll'){
        newSelectedSubjects=[]; 
      }else{
        let indx=newSelectedSubjects.indexOf(subjectID); 
        newSelectedSubjects.splice(indx,1);
      }
      isSubjectAllSelect=false; 
    }
    this.setState({selectedSubjects:newSelectedSubjects,isSubjectAllSelect});
  }
  getSubjectSuggestions(value:string){
    const{subjectList}=this.props;

    this.setState((prevState)=>{
      let suggestions:any=[];
      if(value.length>0){  
        value=value.toLowerCase();
        for(let indx=0; indx<subjectList.length; indx++){
          let ug=subjectList[indx];
          if(ug.name.charAt(0)>value.charAt(0)){
            break;
          }    
          if (ug.name && ug.name.toLocaleLowerCase().search(value) != -1) {
                suggestions.push(ug);
          }
        }
      }else{
        suggestions=[...subjectList];  
      } 
      return {filteredSubjectList:suggestions};
    });
  }
  renderSubjectSelectOption=()=>{
    const { classes,subjectList } = this.props;
    const {
      selectedSubjects,
      isSubjectAllSelect,
      selectedPermission,
      showSubjects,
      filteredSubjectList
    } = this.state;
    return (
      <>
        {selectedPermission === "VIEW" && (
          <Grid container justify="space-between">
            <Grid item xs={3}>
              <Typography className={classes.label}>
                Select Subject
              </Typography>
            </Grid>
            <Grid item xs={8}>
              <img
                className={classes.infoImg}
                src="assets/svg/infoIcon.svg"
              />
              <span className={classes.subText}>
                This field is specifically for selecting subject wise
                questions from a test
              </span>
            </Grid>
          </Grid>
        )}
        {/* <MyPATSelect
                  multiple={true}
                  isNative={false}
                  fullWidthControl
                  required
                  onChange={this.handleSubjectChange}
                  inputId="subject"
                  name="subjects"
                  value={selectedSubjects}
                  customRenderFunc={this.renderer}
                  displayEmpty
                  placeholder={
                    <Typography
                      variant="body2"
                      align="left"
                      inline
                      className={classes.greyText}
                    >
                      Select Subject
                    </Typography>
                  }
                >
                  <MenuItem key={98} value={"selectAll"}>
                      <Checkbox
                        color="primary"
                        checked={isSubjectAllSelect}
                      />
                      <ListItemText primary={'Select All'} />
                    </MenuItem>
                  {(subjectList || []).map(({ _id, name }) => (
                    <MenuItem key={_id} value={_id}>
                      <Checkbox
                        color="primary"
                        checked={selectedSubjects.includes(_id)}
                      />
                      <ListItemText primary={name} />
                    </MenuItem>
                  ))}
                </MyPATSelect>
            */}
        <div className={classes.optionContainer}>
            <div
             onClick={() => {
                  this.setState({ showSubjects: !showSubjects,filteredSubjectList:[...subjectList]});
                }}>
              <input
                type="text"
                // onClick={() => {
                //   this.setState({ showSubjects: !showSubjects });
                // }}
                placeholder="Select Subjects"
                value={this.renderer()}
                disabled={true}
              />
            </div>
            {showSubjects && (
             <div className={classes.optionlistContainer}>
              <div className={classes.optionList}>
                <div className={classes.searchContainer}>
                <input type="text" placeholder="Search Subject" onChange={(event)=>{this.getSubjectSuggestions(event.target.value)}}/>
                <img src="/assets/svg/userManagement/search-icon.svg" />
                </div>
                <span>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={isSubjectAllSelect&&filteredSubjectList.length==selectedSubjects.length}
                        onChange={this.handleSubjectChange}
                        name="Select All"
                        color="primary"
                      />
                    }
                    label="Select All"
                    value="SelectAll"
                  />
                </span>
                {(filteredSubjectList || []).map(({ _id, name }) => (
                   <span>
                   <FormControlLabel
                     control={
                       <Checkbox
                         checked={selectedSubjects.includes(_id)}
                         onChange={this.handleSubjectChange}
                         name="checkedB"
                         color="primary"
                       />
                     }
                     label={name}
                     key={_id} value={_id}
                   />
                 </span>
                  ))}
              </div>
              </div>
            )}
            
          </div>
      </>
    );
  }
  shareContentWithOthers = () => {
    const { classes, contentList,subjectList } = this.props;
    const {
      selectedUsers,
      selectedGroups,
      isShare,
      showSuggestedList,
      suggestedClientsList,
      showFullAlreadyShared,
      allSharedId,
      selectedPermission,
      shareContentWith,
      suggestedUsersList,
      sharedUsersList,
      clientSearchText,
      userSearchText,
      selectedSubjects,
      isSubjectAllSelect
    } = this.state;
    const removedIds: string[] = this.state.removedIds;
    let othersShared = 0;
    const contentCreatorClientIds: Set<string> = new Set(
      contentList.map((content) => _.get(content, "aclMetaData.clientId", ""))
    );
    const finalSuggestedClientList = suggestedClientsList.filter(
      (data: any) =>
        data._id !== getClientId() && !contentCreatorClientIds.has(data._id)
    );

    const finalSuggestedUsersList = suggestedUsersList.filter(
      (data) => !sharedUsersList.find(({ user: { id } }) => id === data._id)
    );

    return (
      <>
        {" "}
        <Grid container alignItems="center">
          <Grid item xs="auto">
            <Typography variant="body2" className={classes.peopleText}>
              Share with:{" "}
            </Typography>
          </Grid>
          <Grid item xs>
            <RadioGroup
              aria-label="Share content with"
              name="shareContentWith"
              className={classes.group}
              // onChange={this.handleChange}
              onChange={this.handleShareContentWith}
            >
              <FormControlLabel
                value="client"
                control={
                  <Radio
                    color="primary"
                    disableRipple={true}
                    checked={shareContentWith === "client"}
                  />
                }
                label="Client"
                classes={{ label: classes.customLabel }}
              />

              <FormControlLabel
                value="users"
                control={
                  <Radio
                    color="primary"
                    disableRipple={true}
                    checked={shareContentWith === "users"}
                  />
                }
                label="Users"
                classes={{ root: classes.customLabel }}
              />
            </RadioGroup>
          </Grid>
          <Grid item xs="auto" style={{ textAlign: "right" }}>
            <Grid className={classes.dFlex}>
            <Typography className={classes.label}>Access:</Typography>
            <select
              className={classes.permissionSelect}
              onChange={this.setPermission}
              value={selectedPermission}
            >
              <option value="VIEW">Can View</option>
              <option value="EDIT">Can Edit</option>
            </select>
                          
            </Grid>
          </Grid>
        </Grid>
        <div className={classes.suggestContainer}>
          <Typography className={classes.label}>Select Client/Org</Typography>
          <SearchField
            placeholder="Enter client name"
            className={classes.searchRoot}
            onFocus={() => {
              this.showSuggested(true);
            }}
            onBlur={() => {
              this.showSuggested(false);
            }}
            onChange={this.getSuggestions("client")}
            value={clientSearchText}
            fullWidth
          />
          {showSuggestedList && finalSuggestedClientList.length > 0 && (
            <ul className={classes.suggestList}>
              {_.map(
                finalSuggestedClientList,
                (sl: any, i: number) =>
                  _.isEmpty(_.find(selectedUsers, ["_id", sl._id])) &&
                  !_.includes(allSharedId, sl._id) && (
                    <li
                      key={`suggest_${i}`}
                      className={[
                        classes.userChipRoot,
                        classes.userChipLabel,
                      ].join(" ")}
                      onClick={() => {
                        this.onClientSuggestionClick(
                          sl._id,
                          shareContentWith === "users"
                        );
                      }}
                    >
                      &nbsp;&nbsp;
                      <span className={classes.seggestedListItem}>
                        {sl.name}
                      </span>
                    </li>
                  )
              )}
            </ul>
          )}
        </div>
        <br />
        <Grid container>
          <Grid item xs>
            <ExpandItems>
              {_.map(selectedGroups, (u: UserGroupsBody) => (
                <Chip
                  key={`userGroup_${u._id}`}
                  classes={{
                    root: classes.userChipRoot,
                    label: classes.userChipLabel,
                  }}
                  label={<span>{u.name}</span>}
                  onDelete={() => {
                    this.removeSelected(u._id, "client");
                  }}
                  deleteIcon={<CloseIcon className={classes.userChipIcon} />}
                />
              ))}
            </ExpandItems>
           
          </Grid>
        </Grid>
        {shareContentWith === "users" && (
          <>
            <div className={classes.suggestContainer}>
            <Typography className={classes.label}>Select Users</Typography>
              <SearchField
                placeholder="Enter user name"
                className={classes.searchRoot}
                onFocus={() => {
                  this.showSuggested(true);
                }}
                onBlur={() => {
                  this.showSuggested(false);
                }}
                onChange={this.getSuggestions("users")}
                value={userSearchText}
                fullWidth
              />
              {showSuggestedList && finalSuggestedUsersList.length > 0 && (
                <ul className={classes.suggestList}>
                  {_.map(
                    finalSuggestedUsersList,
                    (sl: any, i: number) =>
                      !_.includes(allSharedId, sl._id) && (
                        <li
                          key={`suggest_${i}`}
                          className={[
                            classes.userChipRoot,
                            classes.userChipLabel,
                          ].join(" ")}
                          onClick={() => {
                            this.onUserSuggestionClick(sl._id);
                          }}
                        >
                          &nbsp;&nbsp;
                          <span className={classes.seggestedListItem}>
                            {sl.name}
                          </span>
                        </li>
                      )
                  )}
                </ul>
              )}
            </div>
            <br />
            <Grid container>
              <Grid item xs>
                <ExpandItems>
                  {_.map(sharedUsersList, ({ user }) => (
                    <Chip
                      key={`userGroup_${user.id}`}
                      classes={{
                        root: classes.userChipRoot,
                        label: classes.userChipLabel,
                      }}
                      label={<span>{user.name}</span>}
                      onDelete={() => {
                        this.removeSelected(user.id, "users");
                      }}
                      deleteIcon={<CloseIcon className={classes.userChipIcon} />}
                    />
                  ))}
                </ExpandItems>
              </Grid>
            </Grid>
            {selectedPermission !== "EDIT" && this.checkCountInContent("testpapers") > 0&&<div className={classes.suggestContainer}>
             {this.renderSubjectSelectOption()}
        </div>}
        <br />
          </>
        )}
        {selectedPermission === "EDIT" && (
          <Grid style={{ width: "100%" }}>
            <Typography className={classes.sectionAccessHeading}>
              Select section wise access for:
            </Typography>
            <Grid container justify="flex-start">
              {(this.checkCountInContent("testpapers") > 0||this.checkCountInContent("question") > 0) && (
                <Grid className={classes.accessFrame}>
                  <span className={classes.frameHeading}>
                    Content Type - Question
                  </span>
                  <Grid container justify="flex-start">
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Question Content",
                        "question",
                        "content"
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Ideal Time",
                        "question",
                        "idealTime"
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Hints",
                        "question",
                        "hints"
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Solution",
                        "question",
                        "solution"
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Difficulty/ Skill",
                        "question",
                        "difficulty"
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Relevant Exams",
                        "question",
                        "relevantExams"
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Benchmarking",
                        "question",
                        "benchmarking"
                      )}
                    </Grid>
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Extra Tags",
                        "question",
                        "tags"
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {this.checkCountInContent("testpapers") > 0 && (
                <Grid className={classes.accessFrame}>
                  <span className={classes.frameHeading}>
                    Content Type - Test
                  </span>
                  <Grid container justify="flex-start">
                    <Grid item xs={4}>
                      {this.renderPermissionCheckbox(
                        "Basic Details",
                        "test",
                        "basicDetails"
                      )}
                    </Grid>
                    <Grid item xs={7}>
                    {this.renderSubjectSelectOption()}
                    </Grid>
                  </Grid>
                </Grid>
              )}
              {this.checkCountInContent("studymaterial") > 0 && (
                <Grid className={classes.accessFrame}>
                  <span className={classes.frameHeading}>
                    Content Type - Study Material
                  </span>
                  <Grid container justify="flex-start">
                    <Grid item xs={5}>
                      {this.renderPermissionCheckbox(
                        "Notes/Video Content",
                        "studyMaterial",
                        "notes"
                      )}
                    </Grid>
                    <Grid item xs={5}>
                      {this.renderPermissionCheckbox(
                        "Extra Tags",
                        "studyMaterial",
                        "tags"
                      )}
                    </Grid>
                  </Grid>
                </Grid>
              )}
            </Grid>
          </Grid>
        )}
        {/* <Grid container>
          <Grid item xs={12}>
            {contentList.length == 1 && contentList[0] && (
              <>
                {_.map(
                  _.get(contentList, "[0].aclMetaData.allowedTo", []),
                  (c: any, i: number) => {
                    if (
                      _.get(
                        c,
                        "user.id._id",
                        _.get(c, "userGroup.id._id", "")
                      ) == ""
                    ) {
                      return;
                    }
                    if (
                      removedIds.includes(
                        _.get(
                          c,
                          "user.id._id",
                          _.get(c, "userGroup.id._id", "")
                        )
                      )
                    ) {
                      othersShared++;
                      return;
                    }

                    if (!showFullAlreadyShared && i > 1) {
                      return;
                    }

                    return (
                      <Chip
                        key={i}
                        classes={{
                          root: classes.userChipRoot,
                          label: classes.userChipLabel,
                        }}
                        label={_.get(
                          c,
                          "user.id.fullName",
                          _.get(c, "userGroup.id.name", "")
                        )}
                        onDelete={() => {
                          this.removeAlreadyExist(c);
                        }}
                        deleteIcon={
                          <CloseIcon className={classes.userChipIcon} />
                        }
                      />
                    );
                  }
                )}

                {_.get(contentList, "[0].aclMetaData.allowedTo", []).length -
                  removedIds.length -
                  othersShared >
                  2 &&
                  !showFullAlreadyShared && (
                    <Typography
                      className={classes.cursor}
                      variant="body2"
                      color="textSecondary"
                      onClick={() => {
                        this.setState({ showFullAlreadyShared: true });
                      }}
                      inline
                    >
                      +
                      {_.get(contentList, "[0].aclMetaData.allowedTo", [])
                        .length -
                        removedIds.length -
                        othersShared -
                        2}{" "}
                      more
                    </Typography>
                  )}

                {_.get(contentList, "[0].aclMetaData.allowedTo", []).length -
                  removedIds.length -
                  othersShared >
                  2 &&
                  showFullAlreadyShared && (
                    <Typography
                      className={classes.cursor}
                      variant="body2"
                      color="textSecondary"
                      onClick={() => {
                        this.setState({ showFullAlreadyShared: false });
                      }}
                      inline
                    >
                      less
                    </Typography>
                  )}
              </>
            )}
          </Grid>
        </Grid> */}
      </>
    );
  };
  resetEditData() {
    this.setState({
      removedIds: [],
      suggestedClientsList: [],
      selectedUsers: [],
      selectedGroups: [],
      showSuggestedList: false,
      sectionWiseAccess: [],
      selectedPermission: "VIEW",
      sharedUsersList: [],
      selectedSubjects:[],
      isSubjectAllSelect:false
    });
  }

  isShareEnabled = () => {
    const { selectedGroups, sharedUsersList, shareContentWith, selectedPermission, sectionWiseAccess } = this.state;
    if (
      _.isEmpty(selectedGroups) ||
      (shareContentWith === "users" && _.isEmpty(sharedUsersList))
    ) {
      return false;
    }
    return selectedPermission === 'VIEW' || this.shareEnableUtil() ;
  };
 shareEnableUtil=()=>{
  const { selectedGroups, sharedUsersList, shareContentWith, selectedPermission, sectionWiseAccess } = this.state;
      if(sectionWiseAccess.length > 0&&this.checkCountInContent('testpapers')>0){
        for(let i=0; i<sectionWiseAccess.length; i++){
          if(sectionWiseAccess[i].module==='question'&&sectionWiseAccess[i].sections.length>0){
            return true;
          }}
      }
     else{
         return sectionWiseAccess.length > 0; 
     }
   return false;     
 }
  render() {
    const { classes, isShareDialogOpen, contentList } = this.props;
    const { isShare} = this.state;
    return (
      <div>
        <MyPATDialog
          dialogOpen={isShareDialogOpen || isShare}
          customButtonVariant="withoutBorderCloseIcon"
          dialogHeading={
            !isShare
              ? "Share this content with others"
              : "Content Sharing in Progress"
          }
          variantHeader="leftHeader"
          onDialogClose={() => {
            this.setState({ isShare: false });
            this.onShared(false);
          }}
          otherDialogProps={{
            fullWidth: false,
            maxWidth: false,
          }}
          variant="white"
          isborderDialogAction={true}
          customDialogActions={
            <>
              {!isShare ? (
                contentList &&
                contentList.length > 0 && (
                  <>
                    <Link
                      color="primary"
                      classes={{ root: classes.cursorLink }}
                      onClick={() => {
                        this.onShared(false);
                      }}
                    >
                      Cancel
                    </Link>
                    <Button
                      variant="contained"
                      classes={{ root: classes.btnWidth }}
                      color="primary"
                      onClick={() => {
                        this.onShared(true);
                      }}
                      disabled={!this.isShareEnabled()}
                    >
                      Share
                    </Button>

                  </>
                )
              ) : (
                <Button
                  variant="contained"
                  classes={{ root: classes.btnWidth }}
                  color="primary"
                  onClick={() => {
                    this.setState({ isShare: false });
                    this.onShared(false);
                  }}
                >
                  Ok
                </Button>
              )}
            </>
          }
        >
          {!isShare ? (
            <Grid
              container
              justify="center"
              alignItems="center"
              className={classes.widthSM}
            >
              {this.shareContentWithOthers()}
            </Grid>
          ) : (
            <Grid
              container
              justify="center"
              alignItems="center"
              className={classes.widthMD}
            >
              {this.sharingProgress(classes)}
            </Grid>
          )}
        </MyPATDialog>
      </div>
    );
  }
}

const mapStateToProps = (state: any) => ({
  subjectList: state.clientManagement.usersManagement.subjectList,
});
  
const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators(
    {
      usersList,
      getSubjectList
    },
    dispatch
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps
  // @ts-ignore
)(withStyles(styles)(ContentShareModal));
